import * as Types from '../../../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateWebsiteEventGreetingMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.UpdateGreetingInput;
}>;

export type UpdateWebsiteEventGreetingMutation = {
  __typename?: 'Mutation';
  updateWebsiteEventGreeting: { __typename?: 'EventGreetingResponse'; eventId: string; greeting: string };
};

export const UpdateWebsiteEventGreetingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsiteEventGreeting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateGreetingInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWebsiteEventGreeting' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsiteEventGreetingMutationFn = Apollo.MutationFunction<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>;

/**
 * __useUpdateWebsiteEventGreetingMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEventGreetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEventGreetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEventGreetingMutation, { data, loading, error }] = useUpdateWebsiteEventGreetingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWebsiteEventGreetingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>(UpdateWebsiteEventGreetingDocument, baseOptions);
}
export type UpdateWebsiteEventGreetingMutationHookResult = ReturnType<typeof useUpdateWebsiteEventGreetingMutation>;
export type UpdateWebsiteEventGreetingMutationResult = Apollo.MutationResult<UpdateWebsiteEventGreetingMutation>;
export type UpdateWebsiteEventGreetingMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>;
